import React from 'react';

import FooterMenu from './FooterMenu';
import FooterDetails from './FooterDetails';
import FooterCopyright from './FooterCopyright';

function Footer({
  logo = undefined,
  mourning = false,
  menu = [],
  copyright = {},
  widgets = {
    0: [],
    1: [],
    2: [],
    3: []
  },
  handleNewsletters = () => {},
  handleSearch = () => {}
}) {
  return (
    <>
      {menu && menu.length > 0 ? <FooterMenu menu={menu} /> : ''}
      {widgets &&
      ((widgets[0] && widgets[0].length > 0) ||
        (widgets[1] && widgets[1].length > 0) ||
        (widgets[2] && widgets[2].length > 0) ||
        (widgets[3] && widgets[3].length > 0)) ? (
        <FooterDetails
          logo={logo}
          mourning={mourning}
          widgets={widgets}
          handleNewsletters={handleNewsletters}
          handleSearch={handleSearch}
        />
      ) : (
        ''
      )}
      {!(copyright === null) && (
        <FooterCopyright
          owner={copyright.owner}
          period={copyright.period}
          producer={copyright.producer}
          producerHref={copyright.producerHref}
        />
      )}
    </>
  );
}

export default Footer;
